import { BulkActionsDropdown, Space, Text } from '@/components';
import { type ComponentProps, type FC, type ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  textProps?: ComponentProps<typeof Text>;
  title?: ReactNode;
  extraItems?: Array<{ key: string; label: string; onClick: () => void }>;
  isExpandedAllWhenMounted?: boolean;
  openAll: () => void;
  closeAll: () => void;
};

export const ToggleAllButton: FC<Props> = ({
  textProps,
  extraItems,
  isExpandedAllWhenMounted,
  openAll,
  closeAll,
  title,
}) => {
  const { t } = useTranslation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: (migrate from ESLint)
  useEffect(() => {
    if (isExpandedAllWhenMounted) {
      openAll();
    }
  }, []);

  return (
    <Space>
      {textProps && <Text {...textProps} />}
      {title && <>{title}</>}
      <BulkActionsDropdown
        menu={{
          items: [
            { key: 'open-all', label: t('open-all') },
            { key: 'close-all', label: t('close-all') },
            ...(extraItems ?? []),
          ],
          onClick: (e) => {
            switch (e.key) {
              case 'open-all':
                openAll();
                break;
              case 'close-all':
                closeAll();
                break;
            }
          },
        }}
      />
    </Space>
  );
};
